import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "./ImmutableArray.js";
import s from "../geometry/Point.js";

var i = /*#__PURE__*/function (_t) {
  _inherits(i, _t);

  var _super = _createSuper(i);

  function i(t, s, _i, e, h, a) {
    var _this;

    _classCallCheck(this, i);

    _this = _super.call(this, t), _this._lazyPt = [], _this._hasZ = !1, _this._hasM = !1, _this._spRef = s, _this._hasZ = _i, _this._hasM = e, _this._cacheId = h, _this._partId = a;
    return _this;
  }

  _createClass(i, [{
    key: "get",
    value: function get(t) {
      if (void 0 === this._lazyPt[t]) {
        var _i3 = this._elements[t];
        if (void 0 === _i3) return;
        var e = this._hasZ,
            h = this._hasM;
        var a = null;
        a = e && !h ? new s(_i3[0], _i3[1], _i3[2], void 0, this._spRef) : h && !e ? new s(_i3[0], _i3[1], void 0, _i3[2], this._spRef) : e && h ? new s(_i3[0], _i3[1], _i3[2], _i3[3], this._spRef) : new s(_i3[0], _i3[1], this._spRef), a.cache._arcadeCacheId = this._cacheId.toString() + "-" + this._partId.toString() + "-" + t.toString(), this._lazyPt[t] = a;
      }

      return this._lazyPt[t];
    }
  }, {
    key: "equalityTest",
    value: function equalityTest(t) {
      return t === this || null !== t && t instanceof i != !1 && t.getUniqueHash() === this.getUniqueHash();
    }
  }, {
    key: "getUniqueHash",
    value: function getUniqueHash() {
      return this._cacheId.toString() + "-" + this._partId.toString();
    }
  }]);

  return i;
}(t);

export { i as default };